// extracted by mini-css-extract-plugin
module.exports = {"container":"i_JP","header":"i_JQ","icon":"i_JR","label":"i_JS","heading":"i_JT","subheading":"i_JU","list":"i_JV"};